import React from "react";

import { WrapperKeys } from "../../models/AARPWrappers";
import { AARPInternalAPI } from "../../services/AARPInternalAPI";
import { AARPWrapperComponent } from "../AARPWrapper/AARPWrapper";
import classNames from "classnames";
import styles from "./RightRail.css";

let wasCleanuped = false;

export class RightRail extends React.Component<{
  mode?: "Game" | "Home" | "Category" | "Help";
  topGap?: boolean;
}> {
  static displayName = "RightRail";

  containerRef = null;

  componentDidMount() {
    AARPInternalAPI.initRightRail(wasCleanuped);
    this.updateSrcSetAttributes();
  }

  componentWillUnmount() {
    AARPInternalAPI.destoryAdsSlots(this.containerRef);
    wasCleanuped = true;
  }

  componentDidUpdate() {
    this.updateSrcSetAttributes();
  }

  updateSrcSetAttributes() {
    // Directly select <img> and <source> elements within <picture> to reduce the depth of queries
    document
      .querySelectorAll(
        "picture > img[data-src], picture > img[data-srcset], picture > source[data-srcset]"
      )
      .forEach((element) => {
        // Update <img> src and srcset attributes
        if (element.tagName === "IMG") {
          if (element.hasAttribute("data-src")) {
            element.setAttribute("src", element.getAttribute("data-src"));
          }
          if (element.hasAttribute("data-srcset")) {
            element.setAttribute("srcset", element.getAttribute("data-srcset"));
          }
        }
        // Update <source> srcset attributes
        else if (
          element.tagName === "SOURCE" &&
          element.hasAttribute("data-srcset")
        ) {
          element.setAttribute("srcset", element.getAttribute("data-srcset"));
        }
      });
  }

  render() {
    const { mode, topGap } = this.props;

    return (
      <Container ref={(r) => (this.containerRef = r)} topGap={!!topGap}>
        <AARPWrapperComponent wrapperKey={WrapperKeys.NEW_RIGHT_RAIL} />
      </Container>
    );
  }
}

const Container = React.forwardRef<any, any>(
  ({ topGap, ...props }: any, ref) => (
    <div
      className={classNames(styles.container, { [styles.topGap]: topGap })}
      {...props}
      ref={ref}
    />
  )
);
